import EmployeePersonalInformation from './EmployeePersonalInformation.component';

export default EmployeePersonalInformation;
